import { rtkApi as api } from '../rtkApi';

export type ContractTaskStatus =
  | 'pending'
  | 'in_progress'
  | 'blocked'
  | 'completed'
  | 'overdue';

export interface ContractTask {
  _id: string;
  contractId: string;
  title: string;
  description?: string;
  category?: string;
  priority: 'high' | 'medium' | 'low';
  dueDate?: string;
  status: ContractTaskStatus;
  assignedToRole: 'buyer' | 'seller' | 'agent';
  related?: {
    clauseId?: string;
    milestoneId?: string;
    addendumId?: string;
    documentId?: string;
  };
  createdByRole: 'buyer' | 'seller' | 'agent' | 'admin';
  createdAt: string;
  updatedAt: string;
  completedAt?: string;
  completionNote?: string;
  comments?: Array<{
    authorRole: 'buyer' | 'seller' | 'agent' | 'admin';
    authorName?: string;
    comment: string;
    createdAt: string;
  }>;
}

export interface ListContractTasksResponse {
  success: boolean;
  data: ContractTask[];
  count: number;
}

export const tasksApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getContractTasks: builder.query<ListContractTasksResponse, string>({
      query: (contractId) => ({
        url: `/tasks/contract/${contractId}`,
        method: 'GET',
      }),
      providesTags: ['ContractTasks'],
    }),

    createContractTask: builder.mutation<
      { success: boolean; data: ContractTask; message?: string },
      {
        contractId: string;
        title: string;
        description?: string;
        category?: string;
        priority?: 'high' | 'medium' | 'low';
        dueDate?: string;
        assignedToRole: 'buyer' | 'seller' | 'agent';
      }
    >({
      query: ({ contractId, ...data }) => ({
        url: `/tasks/contract/${contractId}`,
        method: 'POST',
        data,
      }),
      invalidatesTags: ['ContractTasks'],
    }),

    updateContractTask: builder.mutation<
      { success: boolean; data: ContractTask; message?: string },
      { taskId: string; updateData: Partial<ContractTask> }
    >({
      query: ({ taskId, updateData }) => ({
        url: `/tasks/${taskId}`,
        method: 'PUT',
        data: updateData,
      }),
      invalidatesTags: ['ContractTasks'],
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetContractTasksQuery,
  useCreateContractTaskMutation,
  useUpdateContractTaskMutation,
} = tasksApi;
